import { render, staticRenderFns } from "./HospitalGUI.vue?vue&type=template&id=43932780&scoped=true&"
import script from "./HospitalGUI.vue?vue&type=script&lang=js&"
export * from "./HospitalGUI.vue?vue&type=script&lang=js&"
import style0 from "./HospitalGUI.vue?vue&type=style&index=0&id=43932780&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43932780",
  null
  
)

export default component.exports